<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">

                <microtags-form :microtag="microtag" :loader="loader" @click="storeMicrotag(microtag)" :showLabels="false"></microtags-form>

            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import microtagsApi from '../../api/microtags'
  import microtagsForm from './Form.vue'
  import Microtag from '../../models/microtag'

  export default {

    components: {
      microtagsForm
    },
    data () {
      return {
        microtag: new Microtag(),
        loader: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Inserisci nuova microtag',
        createButton: {display: false}
      })
    },

    methods: {
      storeMicrotag (microtag) {
        this.loader = true
        microtag.archive_id = this.$store.state.profile.profile.archive.data.id
        microtagsApi.store(microtag)
          .then((response) => {
            toastr.success('La microtag è stata inserita correttamente')
            this.$router.push('/microtags')
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/microtags/Create.vue